import { Routes, Route, RoutesProps, Navigate } from 'react-router-dom';
import React, { Suspense } from 'react';
import ProtectedRoute from './ProtectedRoute';
import Main from '../components/Main';

const Navigation = () => {
  interface ProtectedRouteProps extends RoutesProps {
    authenticationPath: string;
  }
  const defaultProtectedRouteProps: Omit<ProtectedRouteProps, 'outlet'> = {
    authenticationPath: '/home',
  };

  const Home = React.lazy(() => import('../pages/Home/Home'));

  const Success = React.lazy(() => import('../pages/Success/Success'));

  const Search = React.lazy(() => import('../pages/Search/Search'));

  const Feedback = React.lazy(() => import('../pages/Feedback/Feedback'));

  const AboutUs = React.lazy(() => import('../pages/AboutUs/AboutUs'));

  const ContactUs = React.lazy(() => import('../pages/ContactUs/ContactUs'));

  const FirstImport = React.lazy(
    () => import('../pages/FirstImport/FirstImport'),
  );

  const Blogs = React.lazy(() => import('../pages/Blogs/index'));
  const BlogDetailPage = React.lazy(() => import('../pages/Blogs/BlogDetail'));
  const ImportExportGuide = React.lazy(
    () => import('../pages/Blogs/ImportExportGuide'),
  );
  const PointsOfPBR = React.lazy(
    () => import('../pages/Blogs/PointsOfPBR'), // Make sure this file exists: src/pages/Blogs/PointsOfPBR.tsx
  );

  return (
    <>
      <div id="main-wraper">
        <Routes>
          <Route
            path="/"
            element={
              <ProtectedRoute
                {...defaultProtectedRouteProps}
                outlet={<Main />}
              />
            }
          >
            <Route path="/" element={<Navigate to="/home" replace />} />

            <Route
              path="/home"
              element={
                <Suspense fallback={<></>}>
                  <Home />
                </Suspense>
              }
            />

            <Route
              path="/success"
              element={
                <Suspense fallback={<></>}>
                  <Success />
                </Suspense>
              }
            />

            <Route
              path="/search"
              element={
                <Suspense fallback={<></>}>
                  <Search />
                </Suspense>
              }
            />

            <Route
              path="/feedback"
              element={
                <Suspense fallback={<></>}>
                  <Feedback />
                </Suspense>
              }
            />

            <Route
              path="/about-us"
              element={
                <Suspense fallback={<></>}>
                  <AboutUs />
                </Suspense>
              }
            />

            <Route
              path="/contact-us"
              element={
                <Suspense fallback={<></>}>
                  <ContactUs />
                </Suspense>
              }
            />

            <Route
              path="/assist-your-import"
              element={
                <Suspense fallback={<></>}>
                  <FirstImport />
                </Suspense>
              }
            />

            <Route
              path="/blogs"
              element={
                <Suspense fallback={<></>}>
                  <Blogs />
                </Suspense>
              }
            />

            <Route
              path="/blogs/:id"
              element={
                <Suspense fallback={<></>}>
                  <BlogDetailPage />
                </Suspense>
              }
            />

            <Route
              path="/blogs/import-export-guide"
              element={
                <Suspense fallback={<></>}>
                  <ImportExportGuide />
                </Suspense>
              }
            />

            <Route
              path="/blogs/points-for-bpr-business-process-re-engineering"
              element={
                <Suspense fallback={<></>}>
                  <PointsOfPBR />
                </Suspense>
              }
            />
          </Route>
        </Routes>
      </div>
    </>
  );
};

export default Navigation;
